import React from "react";
import { Link } from "react-router-dom";

/** Small "Terms · Privacy" link row for auth pages. */
export default function LegalLinks({ testid = "legal-links" }) {
  return (
    <p className="mt-6 text-center text-xs text-ink-500" data-testid={testid}>
      <Link to="/terms" className="hover:text-ink-900 hover:underline" data-testid={`${testid}-terms`}>Terms of Service</Link>
      <span className="mx-2" aria-hidden>·</span>
      <Link to="/privacy" className="hover:text-ink-900 hover:underline" data-testid={`${testid}-privacy`}>Privacy Policy</Link>
    </p>
  );
}
